"use client";

import Image from "next/image";
import React from "react";
import Slider from "react-slick";

import Section from "../Section";
const styles = new Proxy({"Partners":"Partners-27ab2","SliderItem":"SliderItem-27ab2","SliderItemFlex":"SliderItemFlex-27ab2"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./PartnerSlider.scss";*/

export type CustomContentType =
  | "notaries"
  | "sanofi"
  | "natwest"
  | "neurology"
  | null;

export type SliderItem = {
  image: { url: string };
  altTxt: string;
  width: number;
  height: number;
  sizes: number;
  customContent?: CustomContentType;
};

interface PartnersClientProps {
  title?: string;
  sliderItems: SliderItem[];
}

const SETTINGS = {
  speed: 6000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  arrows: false,
};

const getSliderItems = (items: SliderItem[]): SliderItem[] => {
  const duplicateCount = items.length < 5 ? 5 : items.length < 10 ? 3 : 1;
  return Array(duplicateCount).fill(items).flat();
};

const renderCustomContent = (
  type: CustomContentType,
  imgElement: React.JSX.Element,
) => {
  switch (type) {
    case "notaries":
      return (
        <figure className="mb-0 text-center">
          {imgElement}
          <figcaption className="mt-2">Association of Notaries</figcaption>
        </figure>
      );
    case "sanofi":
      return <div className={styles.SliderItem}>{imgElement}</div>;
    case "neurology":
      return (
        <div className="p-0">
          <div className="my-0">
            {imgElement}{" "}
            <p className="my-0 d-none d-md-block">
              National Institue of Mental Health,
              <br />
              Neurology and Neurosurgery
            </p>
          </div>
        </div>
      );
    case "natwest":
      return (
        <figure className="text-center mb-0">
          {imgElement}
          <figcaption className="mt-3 mb-0">Fintech Accelerator</figcaption>
        </figure>
      );
    default:
      return imgElement;
  }
};

const PartnersClient: React.FC<PartnersClientProps> = ({
  title,
  sliderItems,
}) => {
  return (
    <Section className={styles.Partners} title={title || "Our partners"}>
      <div className="row mt-5">
        <div className="col-12">
          <Slider {...SETTINGS} className="PartnerSlider">
            {getSliderItems(sliderItems).map((partner, index) => {
              const imgElement = (
                <Image
                  src={partner.image.url}
                  alt={partner.altTxt}
                  className="img-fluid"
                  sizes={partner.sizes + "px"}
                  width={partner.width}
                  height={partner.height}
                />
              );

              return (
                <div key={index} className={styles.SliderItem}>
                  <div>
                    {partner.customContent
                      ? renderCustomContent(partner.customContent, imgElement)
                      : imgElement}
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </Section>
  );
};

export default PartnersClient;
